import React from "react";
import { t, dateLocale } from "../../../i18n/locale";

interface TabletLayoutProps {
  station: string;
  children: React.ReactNode;
}

/**
 * Tablet Layout - Full-screen base layout for station tablets
 * No navigation, auto-refresh, large font for visibility from distance
 */
const TabletLayout: React.FC<TabletLayoutProps> = ({ station, children }) => {
  const currentTime = new Date().toLocaleTimeString(dateLocale(), {
    hour: "2-digit",
    minute: "2-digit",
  });

  const currentDate = new Date().toLocaleDateString(dateLocale(), {
    weekday: "short",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return (
    <div className="tablet-layout">
      <div className="tablet-header">
        <div className="station-info">
          <h1 className="station-name">{station}</h1>
          <p className="station-subtitle">{t("Proizvodni monitor")}</p>
        </div>
        <div className="time-info">
          <div className="current-time">{currentTime}</div>
          <div className="current-date">{currentDate}</div>
        </div>
      </div>

      <div className="tablet-content">{children}</div>

      <style>{`
        .tablet-layout {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: #1a1d29;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .tablet-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem 2rem;
          background: linear-gradient(135deg, #2a2f3e 0%, #1e222e 100%);
          border-bottom: 3px solid #007bff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        }

        .station-info {
          display: flex;
          flex-direction: column;
        }

        .station-name {
          font-size: 2.5rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .station-subtitle {
          font-size: 1.2rem;
          color: #adb3bd;
          margin: 0.25rem 0 0 0;
        }

        .time-info {
          text-align: right;
        }

        .current-time {
          font-size: 3rem;
          font-weight: 700;
          color: #007bff;
          font-family: 'Courier New', monospace;
          line-height: 1;
        }

        .current-date {
          font-size: 1.3rem;
          color: #adb3bd;
          margin-top: 0.5rem;
        }

        .tablet-content {
          flex: 1;
          overflow-y: auto;
          padding: 2rem;
        }

        /* Large touch-friendly design */
        .tablet-content * {
          font-size: 1.2rem;
        }

        @media (max-width: 768px) {
          .tablet-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }

          .time-info {
            text-align: left;
          }

          .station-name {
            font-size: 2rem;
          }

          .current-time {
            font-size: 2.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TabletLayout;
